export const PRINT_CUSTOM_STYLES_A4 = {
  spacingSize: 14,
  halfSpacingSize: 7,
  horizontalItemGridSpacing: 4,
  verticalItemGridSpacing: 2,
  itemImgSize: 50,
  urlLogoSize: 50,
  mainTitleTextSize: 20,
  sectionTitleTextSize: 13,
  regularTextSize: 11,
}

export const PRINT_CUSTOM_STYLES_A5 = {
  spacingSize: 8,
  halfSpacingSize: 4,
  horizontalItemGridSpacing: 3,
  verticalItemGridSpacing: 1.5,
  itemImgSize: 40,
  urlLogoSize: 40,
  mainTitleTextSize: 15,
  sectionTitleTextSize: 11,
  regularTextSize: 9,
}

export const DISPLAY_CUSTOM_STYLES = {
  spacingSize: 20,
  halfSpacingSize: 10,
  horizontalItemGridSpacing: 6,
  verticalItemGridSpacing: 3,
  itemImgSize: 70,
  urlLogoSize: 70,
  mainTitleTextSize: 23,
  sectionTitleTextSize: 15,
  regularTextSize: 13,
}